import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { showError, showSuccess } from "ReduxErrorBar";
import { COMMON_FAIL_MESSAGE } from "Constants";
import EditRewards from "./editrewards";
import LocaleStrings from "Languages";

var Loader = require("react-loaders").Loader; // import "AwesomeLoaderCss";

class RewardssettingsInside extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      desc: LocaleStrings.gamification_text_preparing_analytics,
      loader: false,
    };
  }

  //
  componentDidMount() {
    this.setState({ loading: !this.state.loading });
  }

  //Arrow function for renderLoader
  renderLoader = () => {
    return (
      <Loader type="line-scale-pulse-out-rapid" active className="loader-div" />
    );
  };

  // Arrow function for render Sponsors Insights menu divs

  newfc(obj) {
    this.setState({ loader: !this.state.loader });
  }

  // On Form Submit Challenges
  onFormSubmit(values) {
    var searchVal = document.getElementById(
      "gamification_manage_challenges_searchid"
    ).value;

    var maxDisplayOrderObj = this.props.maxDisplayorder.data;
    var data = { ...values };
    var challenge = this.props.initialValues;

    // If initialValues is blank time of add
    if (Object.keys(challenge).length == 0) {
      var keys = Object.keys(maxDisplayOrderObj);
      var displayorder = keys[0];
      values = { ...values, displayorder };
      values.displayorder = maxDisplayOrderObj.displayorder;
      data = { ...values };
    }

    this.setState({ loading: true });

    this.props.insertChallenge(
      this.props.session,
      data,
      challenge,
      (result) => {
        if (result.error) {
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.props.reset();
          this.close();
          this.props.showSuccess("Challenge updated successfully!");

          /**** Refresh table data after form submit ****/

          if (
            this.props.managechallengesSelectedTab == "MANAGECHALLENGES_SINGLE"
          ) {
            // Single Challenge
            this.props.fetchManageChallengesList(
              this.props.session,
              searchVal,
              "single",
              (CallBackResponse) => {}
            );
          } else {
            // For Recurring Chaleenges call
            this.props.fetchManageChallengesList(
              this.props.session,
              searchVal,
              "recurring",
              (CallBackResponse) => {}
            );
          }
        }
        this.setState({ loading: false });
      }
    );
  }

  render() {
    let { deviceSize } = this.props;

    return (
      <div className="panel noborder-panel">
        <div className="content-header-bar">
          <div className="custom-text3-primary-medium">
            {LocaleStrings.gamification_submenu_title3}
          </div>
        </div>

        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - 70 }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              {this.renderLoader()}
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : (
            <EditRewards history={this.props.history} />
          )}
        </div>
      </div>
    );
  }
}

function validate(values, props) {
  var errors = {};
  var requiredFields = [
    "challengename",
    "challengedesc",
    "rewardtype",
    "challengetype",
    "points",
    "isrecurring",
    "showpopup",
  ];

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = "Required";
    }
  });

  // Code change ~ Tapas
  // let regexp =  /^(?:(ftp|http|https):\/\/)?(?:[\w-]+\.)+[a-z]{2,6}$/;
  let regexp =
    /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;

  requiredFields.forEach((field) => {
    let value = values[field];
  });

  return errors;
}

function mapStateToProps(state) {
  var { session, user } = state;

  //

  return {
    session,
    user,
    deviceSize: state.deviceSize,
    rewardData: state.rewardData,
  };
}

// Export with connect
export default connect(mapStateToProps, {
  showError,
  showSuccess,
})(RewardssettingsInside);
